import { defineNuxtRouteMiddleware, createError } from '#app'
import {JobSeoCategory} from "~/types/constants";

export default defineNuxtRouteMiddleware(async (to) => {
  const { public: { wadApiBaseUrl } } = useRuntimeConfig();
  const localePath = useLocalePath()
  const routeCategoryType = to.params.type as string
  // Remove type from the params payload as it is unnecessary
  const { type, ...otherParams } = to.params;
  const otherParamValues = Object.values(otherParams).filter(Boolean);
  let errorStatus: number|null = null;
  let redirectUrl: string|null = null;

  const response = await useFetch<JobCategoryPageMetaData>('/v2/filter/jobs/category-page/meta-data', {
    baseURL: wadApiBaseUrl,
    credentials: 'omit',
    redirect: 'manual',
    query: {
      type: routeCategoryType,
      'params[]': otherParamValues,
    },
    onResponse({response}) {
      const responseData = response._data as JobCategoryPageMetaData;
      if(!responseData?.valid) {
        errorStatus = 404;
        return;
      }
      if(responseData.redirect) {
        const redirectData = responseData.redirect as JobCategoryRedirectData;
        switch (redirectData.type) {
          case JobSeoCategory.Location: {
            redirectUrl = localePath({
              name: 'job-category-location',
              params: {
                type: JobSeoCategory.Location,
                category: redirectData.country,
                location: redirectData.city
              }
            });
            break;
          }
          case JobSeoCategory.LocationSkill: {
            redirectUrl = localePath({
              name: 'job-category-location',
              params: {
                type: JobSeoCategory.LocationSkill,
                category: redirectData.country,
                location: redirectData.city,
                skill: redirectData.skill,
              }
            });
          }
        }
      }
    },
    onResponseError() {
      errorStatus = 404;
    },
  });

  if(errorStatus) {
    throw showError({ statusCode: errorStatus ?? 500, fatal: true });
  }

  if(redirectUrl) {
    return navigateTo(redirectUrl, { redirectCode: 301 })
  }

  const metadata = useState<JobCategoryPageMetaData|null>('jobCategoryMetadata', () => null)
  const { data: responseData } = response;

  metadata.value = responseData.value as JobCategoryPageMetaData ?? null;
})
